var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"html-container",class:{ 'state-changes': !_vm.showChanges },style:({ zoom: _vm.modal ? _vm.modalFontSize : _vm.fontSize })},[_vm._t("default",[_vm._v(" Нема садржаја странице ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }